import { render, staticRenderFns } from "./TableOutputs.vue?vue&type=template&id=18d646db&"
import script from "./TableOutputs.vue?vue&type=script&lang=js&"
export * from "./TableOutputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports